export default __webpack_public_path__ + "static/media/zalo_icon.a6ba5381.svg";